module.exports = __webpack_public_path__ + "static/img/leiniao_visitor_bg.0c59554e.png";